const filters = {
  header: {
    title: "عوامل تصفية المحتوى",
    description: "تصل المنشورات المطابقة إلى قائمة الانتظار، بينما تُنقل المنشورات غير المطابقة مباشرة إلى الأرشيف.",
  },
  caseSensitive: {
    label: "مطابقة حالة الأحرف",
    enabled: "تم تفعيل المطابقة مع مراعاة حالة الأحرف",
    disabled: "تم تعطيل المطابقة مع مراعاة حالة الأحرف",
  },
  positive: {
    label: "الكلمات المفتاحية الإيجابية (تُفعّل المعالجة)",
    inputLabel: "إضافة كلمة مفتاحية أو عبارة إيجابية",
    placeholder: "مثال: AI، startup، benchmark",
    empty: "لم تتم إضافة كلمات مفتاحية إيجابية. إذا لم تُحدَّد كلمات أو وسوم، فستُعتبر جميع المنشورات المجمعة مطابقة.",
    remove: "إزالة الكلمة المفتاحية الإيجابية {{value}}",
  },
  hashtags: {
    label: "الوسوم المطلوبة",
    inputLabel: "إضافة وسم مطلوب",
    placeholder: "tech، ai، health",
    empty: "لم تتم إضافة وسوم مطلوبة.",
    remove: "إزالة الوسم {{value}}",
  },
  negative: {
    label: "الكلمات المفتاحية السلبية (تجاهل/أرشفة فورًا)",
    inputLabel: "إضافة كلمة مفتاحية أو عبارة سلبية",
    placeholder: "مثال: promo، airdrop، crypto، spam",
    empty: "لم تتم إضافة كلمات مفتاحية سلبية. أضف كلمات مثل «spam» أو «ad» لاستبعاد المنشورات المطابقة تلقائيًا.",
    remove: "إزالة الكلمة المفتاحية السلبية {{value}}",
  },
  actions: {
    addPositive: "إضافة كلمة مفتاحية إيجابية",
    addHashtag: "إضافة وسم مطلوب",
    addNegative: "إضافة كلمة مفتاحية سلبية",
  },
} as const;

export default filters;
